export default __webpack_public_path__ + "09b6c12d5381d1f37e66566e0a1a60d9.png";